'use client';
import React from 'react';
import { useLang } from '@/lib/langContext';

export default function LanguageToggle({ className = '' }: { className?: string }) {
  const { lang, setLang } = useLang();

  return (
    <button
      onClick={() => setLang(lang === 'en' ? 'ar' : 'en')}
      className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-btn border border-[hsl(var(--border))] text-sm font-medium text-[hsl(var(--muted-foreground))] hover:text-[hsl(var(--foreground))] hover:border-navy-200 transition-all duration-150 ${className}`}
      aria-label={lang === 'en' ? 'Switch to Arabic' : 'Switch to English'}
    >
      <span className="text-xs font-semibold tracking-wide">{lang === 'en' ? 'AR' : 'EN'}</span>
      <span className="text-[hsl(var(--border))]">|</span>
      <span className="text-xs">{lang === 'en' ? 'العربية' : 'English'}</span>
    </button>
  );
}